import { GetChannelConfigFunction } from '@root/libs/init-channel/types';
import { Data, DataComments } from '@root/modules/article/types/article';
import { Route } from 'vue-router';
import { mergeAdsPlacements } from '@ads/utils/mergeAdsPlacements';
import adFormConfig from '@ads/config/adForm.config';

export default function getArticleAdsSettings({
  $channelConfig,
  $route,
  article,
}: {
  $channelConfig: GetChannelConfigFunction;
  $route: Route;
  article: Data | DataComments;
}) {
  const { id } = $channelConfig('settings');
  const { adForm } = $channelConfig('ads').component;

  const keyValue = [`www.delfi.lt:${id}`];

  // Create keywords data
  const keywords = [`${id}`, `${article.id}`, `${article.primaryCategory.slug}`, `cid-${article.primaryCategory.id}`];

  const parentCategory = article.primaryCategory.parentCategory || null;
  if (parentCategory && parentCategory.id && parentCategory.id.toString() !== $channelConfig('settings').externalId) {
    // Add parent category slug
    const parentSlug = parentCategory.slug;
    keywords.push(parentSlug);

    // Add parent category cid keyword
    const parentCid = `cid-${parentCategory.id}`;
    keywords.push(parentCid);
  }

  if (article.tags.items) {
    article.tags.items.forEach((tag) => {
      keywords.push(`ck-${tag.slug}`);
    });
  }

  if (article.content.paywall.enabled) {
    keywords.push(`paid_article`);
  }

  // Get page placements
  const { component } = $channelConfig('page').category;
  const categorySlug = $route.params.subcategory ? $route.params.subcategory : $route.params.category;
  const channelAdsConfig = component?.adForm?.filter((ad) => ad.categories.includes(categorySlug)) || [];
  const channelPlacements: Record<string, unknown> = adForm.placements || {};
  const placements = channelAdsConfig[0]?.placements ? mergeAdsPlacements(channelPlacements, channelAdsConfig[0]?.placements) : channelPlacements;
  let disableAds = $channelConfig('page').article.component?.adForm?.disableAds || adForm.disableAds;
  const enableAds = $channelConfig('page').article.component?.adForm?.enableAds || [];

  // Disable all ads if disableAds attribute is set
  const articleDisableAds = article.settings.disableAds;
  if (articleDisableAds) {
    disableAds = adFormConfig.types;
  }

  return {
    mkw: keywords,
    mkv: keyValue,
    placements,
    disableAds,
    enableAds,
    uniqueKey: [`${id}_${article.primaryCategory.slug}`],
  };
}
